import { render } from "./PauseBefore.vue?vue&type=template&id=206da718&scoped=true"
import script from "./PauseBefore.vue?vue&type=script&lang=js"
export * from "./PauseBefore.vue?vue&type=script&lang=js"

import "./PauseBefore.vue?vue&type=style&index=0&id=206da718&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206da718"]])

export default __exports__